export const FIELD_TYPES = [
  { value: 'text',     label: 'Texto corto' },
  { value: 'textarea', label: 'Texto largo' },
  { value: 'number',   label: 'Número' },
  { value: 'date',     label: 'Fecha' },
  { value: 'select',   label: 'Selección (desplegable)' },
  { value: 'boolean',  label: 'Sí / No' },
  { value: 'email',    label: 'Email' },
  { value: 'phone',    label: 'Teléfono' },
  { value: 'file',     label: 'Archivo' },
];

export const PHONE_PATTERNS = {
  '+34': { regex: /^[679]\d{8}$/, hint: '9 dígitos, empieza por 6, 7 o 9' },
  '+351': { regex: /^\d{9}$/, hint: '9 dígitos' },
  '+33': { regex: /^[0-9]\d{8}$/, hint: '9 dígitos' },
  '+49': { regex: /^\d{10,11}$/, hint: '10 u 11 dígitos' },
  '+44': { regex: /^[0-9]\d{9,10}$/, hint: '10 u 11 dígitos' },
  '+1':  { regex: /^\d{10}$/, hint: '10 dígitos' },
  '+39': { regex: /^[0-9]\d{8,9}$/, hint: '9 o 10 dígitos' },
};

export const PHONE_EXTENSIONS = [
  { value: '+34', flag: '🇪🇸', label: '+34 España' },
  { value: '+351', flag: '🇵🇹', label: '+351 Portugal' },
  { value: '+33', flag: '🇫🇷', label: '+33 Francia' },
  { value: '+49', flag: '🇩🇪', label: '+49 Alemania' },
  { value: '+44', flag: '🇬🇧', label: '+44 Reino Unido' },
  { value: '+1',  flag: '🇺🇸', label: '+1 EEUU/Canadá' },
  { value: '+39', flag: '🇮🇹', label: '+39 Italia' },
];

export const DOC_TYPES = [
  { value: 'dni',        label: 'DNI',                   regex: /^\d{8}[A-Z]$/i,          hint: '8 dígitos + letra (ej: 12345678Z)' },
  { value: 'nie',        label: 'NIE',                   regex: /^[XYZ]\d{7}[A-Z]$/i,     hint: 'Letra + 7 dígitos + letra (ej: X1234567Z)' },
  { value: 'residencia', label: 'Tarjeta de residencia', regex: /^[A-Z0-9]{6,20}$/i,       hint: '6-20 caracteres alfanuméricos' },
  { value: 'pasaporte',  label: 'Pasaporte',             regex: /^[A-Z0-9]{6,12}$/i,       hint: '6-12 caracteres alfanuméricos' },
];

export function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function validatePhone(phone, ext) {
  const p = PHONE_PATTERNS[ext];
  if (!p) return /^\d{6,15}$/.test(phone.replace(/\s/g, ''));
  return p.regex.test(phone.replace(/\s/g, ''));
}

export function validateDoc(num, type) {
  const dt = DOC_TYPES.find(d => d.value === type);
  if (!dt) return true;
  return dt.regex.test(num.trim().toUpperCase());
}
